import { Card, styled } from '@mui/material';

const PREFIX = 'AccountDetails';

export const classes = {
  root: `${PREFIX}-root`,
};

export const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(4),
  },
}));
